// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".obutton.added[data-v-4fbdc2fe]{--bg-opacity:1!important;background-color:#21cf00!important;background-color:rgba(33,207,0,var(--bg-opacity))!important}.obutton.disabled[data-v-4fbdc2fe]{--bg-opacity:1!important;background-color:#e0e0e0!important;background-color:rgba(224,224,224,var(--bg-opacity))!important;--text-opacity:1!important;color:#374151!important;color:rgba(55,65,81,var(--text-opacity))!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
